import  firebase from 'firebase'
// import firestore from 'firebase/firestore'

// Your web app's Firebase configuration
 var firebaseConfig = {
  apiKey: "AIzaSyDxtFPYPTFywp1QqJiPMcSiodtOYH4LvOw",
  authDomain: "curso-cann-app.firebaseapp.com",
  projectId: "curso-cann-app",
  storageBucket: "curso-cann-app.appspot.com",
  messagingSenderId: "608672220168",
  appId: "1:608672220168:web:41d54f98774f1ff24ffdbd",
  measurementId: "G-W1G8C9RK1K"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebaseApp.analytics();

export default firebaseApp.firestore()